import { useContext, useState } from 'react';

import Button from '@ingka/button';
import { t } from '@onlinepayments/payments-library';

import OrderListItemImage from '../../../../components/OrderItemList/OrderListItemImage';
import PriceComponent from '../../../../components/PriceComponent';
import { LineType } from '../../../../enums/LineType';
import { OrderDetailsContext } from '../../../../OrderDetailsContext';
import { PayorderContext } from '../../../../PayorderContext';
import { OrderSummaryModal } from '../OrderSummaryModal';

import './OrderSummary.scss';

const PREVIEW_COUNT = 3;

export const OrderSummary = () => {
  const { order, orderItems } = useContext(OrderDetailsContext);
  const {
    contextState: { amountLeftToPay },
  } = useContext(PayorderContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!order || !orderItems) return null;

  const productItems = orderItems.filter(
    ({ orderLine }) =>
      orderLine?.lineType === LineType.Item || orderLine?.lineType === LineType.Service,
  );
  const previewItems = productItems.slice(0, PREVIEW_COUNT);
  const remainingCount = productItems.length - previewItems.length;

  return (
    <div className="OrderSummary">
      <button
        type="button"
        className="OrderSummary__title"
        onClick={() => setIsModalOpen(true)}
        data-testid="openOrderSummaryModal"
      >
        <h2 className="OrderSummary__title-text">
          {t('order_info_header')} ({productItems.length})
        </h2>
      </button>

      {previewItems.length > 0 && (
        <div className="OrderSummary__thumbnails">
          {previewItems.map(({ salesItem }) => (
            <div className="OrderSummary__thumbnail" key={salesItem.itemKey.itemNo}>
              <OrderListItemImage item={salesItem} />
            </div>
          ))}
          {remainingCount > 0 && (
            <Button
              className="OrderSummary__more"
              type="tertiary"
              size="small"
              text={`+${remainingCount}`}
              aria-label={t('payment.payment_product_list', undefined, {
                numberOfProducts: '' + productItems.length,
              })}
              onClick={() => setIsModalOpen(true)}
              data-testid="openOrderSummaryModalMore"
            />
          )}
        </div>
      )}

      <div className="OrderSummary__section">
        <p className="OrderSummary__label mb-0 text-bold">{t('order.order_number')}</p>
        <p className="mb-0">{order.orderNumber}</p>
      </div>

      <div className="OrderSummary__section">
        <h3 className="OrderSummary__section-title">{t('order.order_total_header')}</h3>
        <PriceComponent
          orderAmounts={order.orderAmounts}
          amountLeftToPay={amountLeftToPay ?? 0}
          orderCurrency={order.currency}
        />
      </div>

      <OrderSummaryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        items={productItems}
        currency={order.currency}
      />
    </div>
  );
};
